var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadminton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.032 504.032",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAB1BA"
    },
    d: "M37.839,379.034l42.7,42.7l42.7,42.7l8.5,8.5c-29.9,29.9-78.5,35.8-108.4,6s-23.9-78.5,6-108.4 L37.839,379.034z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF4F7"
    },
    d: "M413.339,88.934l17,110.9c0,0-145.1,93.9-276.5,149.3c54.7-132.2,148.5-277.3,148.5-277.3 L413.339,88.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF4F7"
    },
    d: "M199.939,396.134l42.7-34.1c97.3-85.3,206.5-134.8,206.5-134.8l49.5,66.6l-8.5,34.1 c0,0-136.5,25.6-281.6,76.8L199.939,396.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF4F7"
    },
    d: "M140.239,259.634l-34.1,42.7l-8.5-8.5c51.2-136.5,93.9-281.6,93.9-281.6l34.1-8.5l49.4,50.2 C275.039,53.934,225.539,161.434,140.239,259.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF4F7"
    },
    points: "165.639,434.334 165.639,434.334 123.139,464.434 80.539,421.734 117.039,385.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF4F7"
    },
    points: "152.639,349.634 117.039,385.234 67.839,336.634 67.839,336.634 97.539,293.734  106.139,302.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF4F7"
    },
    points: "67.839,336.634 117.039,385.234 80.539,421.734 37.839,379.034 67.839,336.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF4F7"
    },
    points: "199.939,396.134 208.539,404.634 165.639,434.334 165.639,434.334 117.039,385.234  152.639,349.634  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF4F7"
    },
    points: "116.939,391.634 86.839,421.734 123.639,458.534 158.739,433.734 121.039,395.734  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51565F"
    },
    d: "M502.239,291.034l-49.5-66.6c-1.3-1.7-3.5-2.3-5.5-1.4c-1.1,0.5-108.9,49.8-204.8,133.1 c-0.9,0.8-1.9,1.6-2.8,2.4c-1.9,1.6-2.1,4.5-0.4,6.4c1.6,1.9,4.5,2.1,6.4,0.4c0.9-0.8,1.8-1.6,2.8-2.4 c85.6-74.3,180.7-121.3,199.4-130.2l46,61.9l-7.3,29.3c-20.3,4-145.4,29.4-276.7,75.5l-6.6-6.6l-42.5-41.7 c129-55.2,270.7-146.6,272.2-147.6s2.3-2.7,2-4.5l-17.2-110.8c-0.3-1.9-1.8-3.5-3.8-3.8l-110.9-17c-1.8-0.3-3.5,0.5-4.5,2 c-0.9,1.4-92.3,143.2-146.8,273l-42.4-43.3l-6.5-6.5c46.6-124.7,86.4-257.1,92.2-276.7l29.1-7.3l45.5,46.3 c-8.4,17.5-56.4,114-132.8,201.8c-1.6,1.9-1.4,4.7,0.4,6.3c1.9,1.6,4.7,1.4,6.3-0.4c84.8-97.5,135-205.6,135.5-206.7 c0.8-1.7,0.4-3.7-0.9-5l-49.4-50.5c-1.1-1.1-2.8-1.6-4.3-1.2l-34.1,8.5c-1.5,0.4-2.8,1.6-3.2,3.1c-0.4,1.4-43.1,146.1-93.6,280.8 l-29.4,42.3l0,0l-27,38.1l-4.8-4.8c-1.8-1.8-4.6-1.8-6.4,0c-15.4,15.4-25.1,36.2-26.7,57c-1.7,22.2,5.7,42.7,20.7,57.7 c13.7,13.7,31.5,21,51.5,21c23,0,46.1-9.8,63.2-26.9c1.8-1.8,1.8-4.6,0-6.4l-4.8-4.8l38.1-27l0,0l42.3-29.3 c142.8-50.4,279-76.2,280.4-76.4c1.7-0.3,3.1-1.6,3.5-3.3l8.5-34.1C503.339,293.534,503.039,292.134,502.239,291.034z  M304.539,76.734l99.4,15.3l-109.1,107.9c-1.8,1.7-1.8,4.6,0,6.4c0.9,0.9,2,1.3,3.2,1.3c1.1,0,2.3-0.4,3.2-1.3l109.1-107.8 l15.3,99.2c-19.1,12.2-145.6,91.9-263.1,143C212.739,222.434,292.439,95.834,304.539,76.734z M98.239,300.734l4.7,4.7l43.4,44.2 l-14.7,14.7l-14.7,14.6l-43.2-42.9L98.239,300.734z M123.639,458.534l-36.8-36.8l30.1-30.1l4.1,4.1l37.7,38L123.639,458.534z  M68.439,343.534l42.1,41.8l-30.1,30.1l-36.8-36.8L68.439,343.534z M71.739,494.034c-17.6,0-33.2-6.3-45.2-18.3 c-25.5-25.5-24-69,2.9-98.7l86.4,86.4l4.2,4.2l0,0l5.3,5.3C110.239,486.334,90.939,494.034,71.739,494.034z M166.239,428.534 l-42.9-43.3l14.7-14.7l14.6-14.6l44.1,43.4l4.7,4.7L166.239,428.534z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/badminton.1fca95c21fa0ace1e47e37d9af63cd73.svg";
export { ForwardRef as ReactComponent };